export default {
  "waybill": {
    "check_the_postcode": "Check the post code.",
    "region": "Region"
  }
}